// extracted by mini-css-extract-plugin
export var aside = "Page-module--aside--mE393";
export var nonSnappingPage = "Page-module--nonSnappingPage--OZiHt";
export var pageFooter = "Page-module--pageFooter--jx2H-";
export var scrollUp = "Page-module--scrollUp--h-lMO";